import { defineMessages } from 'react-intl';

export default defineMessages({
  readMore: {
    id: 'app.productCard.components.ReadMore.readMore',
    defaultMessage: 'Leer más',
  },
  readLess: {
    id: 'app.productCard.components.ReadMore.readLess',
    defaultMessage: 'Leer menos',
  },
});
